import api from '../api';
import { Pharmacy } from '../../stores/pharmacyStore';

export interface SetActivePharmacyDto {
  pharmacyId: string;
}

class PharmacyApi {
  private readonly baseUrl = '/api/pharmacies';

  async getUserPharmacies(): Promise<Pharmacy[]> {
    const response = await api.get<Pharmacy[]>(this.baseUrl);
    return response.data;
  }

  async getPharmacy(id: string): Promise<Pharmacy> {
    const response = await api.get<Pharmacy>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async getActivePharmacy(): Promise<Pharmacy | null> {
    try {
      const response = await api.get<Pharmacy>(`${this.baseUrl}/active`);
      return response.data;
    } catch (error) {
      // If no active pharmacy is set, return null
      return null;
    }
  }

  async setActivePharmacy(pharmacyId: string): Promise<Pharmacy> {
    const response = await api.post<Pharmacy>(`${this.baseUrl}/active`, {
      pharmacyId,
    } as SetActivePharmacyDto);
    return response.data;
  }

  async createPharmacy(data: Partial<Pharmacy>): Promise<Pharmacy> {
    const response = await api.post<Pharmacy>(this.baseUrl, data);
    return response.data;
  }

  async updatePharmacy(id: string, data: Partial<Pharmacy>): Promise<Pharmacy> {
    const response = await api.put<Pharmacy>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async deletePharmacy(id: string): Promise<void> {
    await api.delete(`${this.baseUrl}/${id}`);
  }

  async checkConnection(pharmacyId: string): Promise<{ status: 'ok'; timestamp: Date }> {
    const response = await api.get<{ status: 'ok'; timestamp: Date }>(
      `${this.baseUrl}/${pharmacyId}/health`
    );
    return response.data;
  }
}

export const pharmacyApi = new PharmacyApi();